import React from 'react';

import { EluveNameLogo, VStack } from '@eluve/components';

import { useInterstitials } from './hooks/useInterstitials';

export const InterstitialOverlay: React.FC = () => {
  const { activeInterstitial, isLoading, context } = useInterstitials();

  if (!activeInterstitial || isLoading || !context) {
    return null;
  }

  const FlowComponent = activeInterstitial.component;

  if (activeInterstitial.transparentBackground) {
    return (
      <VStack
        className="fixed inset-0 z-50"
        role="dialog"
        aria-modal="true"
        aria-labelledby="interstitial-title"
      >
        <FlowComponent context={context} />
      </VStack>
    );
  }

  return (
    <VStack
      className="fixed inset-0 z-50 items-center justify-center gap-10 bg-bg-secondary p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="interstitial-title"
    >
      <EluveNameLogo height={64} />
      <VStack className="mx-auto size-fit rounded-xl bg-white shadow">
        <FlowComponent context={context} />
      </VStack>
    </VStack>
  );
};
